import t from 'tcomb';
import Number_Format from '../domain/Number_Format';
import format from 'simple-format-number';

export default function formatNumber(n: t.Number, numberFormat: Number_Format): t.String {
  return format(n, {
    fractionDigits: numberFormat.digits,
    symbols: {
      decimal: numberFormat.decimal_symbol,
      grouping: numberFormat.grouping_symbol
    }
  });
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/formatNumber.js
 **/